import React, { useState, useEffect } from 'react'
import { useTranslation } from 'i18n'
import AwesomeDebouncePromise from 'awesome-debounce-promise'
import Share from 'images/inline/share.svg'
import './BreakShareButton.scss'

const BreakShareButton = ({ sidenavActive, children }) => {
  const { t } = useTranslation('common')
  const [shareActive, setShareActive] = useState(false)

  const toggleShareTooltip = async function (e) {
    if (e.type === 'mouseover' || e.key === 'Enter') {
      setShareActive(true)
    } else {
      setShareActive(false)
    }
    console.log(shareActive)
  }

  const toggleShareTooltipDebounced = AwesomeDebouncePromise(
    toggleShareTooltip,
    200,
  )

  //When the sidebar is deactivated, and then comes back, we don't want the share tooltip to remain
  useEffect(() => {
    console.log()
    sidenavActive === false && setShareActive(false)
  }, [sidenavActive])

  return (
    <div
      className={`break-share-container`}
      onMouseOver={toggleShareTooltipDebounced}
      onMouseOut={toggleShareTooltipDebounced}
    >
      <button
        tabIndex={0}
        onKeyUp={toggleShareTooltipDebounced}
        className={`break-share-button`}
      >
        <Share />
        <span>{t('share')}</span>
      </button>
      <div className={`break-share-tooltip ${shareActive ? 'is--active' : ''}`}>
        {children}
      </div>
    </div>
  )
}
export default BreakShareButton
